import { useEffect, useMemo, useState } from "react"
import { GetApp } from "../../App"
import { AppData } from "../../App/AppData"
import { Platform } from "../../App/Platform"
import { logger } from "../../App/Logger"
import { serverAppURL } from "../../App/ServerURL"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { LoginWelcomeViewProps } from "./Params"

function NativeWelcomeMessage() {
  const app = GetApp();
  const t = app.getT("LoginView");
  const iOSApp = Platform.isIOS(app);
  const [attempt, setAttempt] = useState(0);
  const apiClient = app.apiClient;
  const request = useMemo(() => ({ apiClient, attempt }), [apiClient, attempt]);
  const [result, setResult] = useState<{ request: typeof request; host?: string; failed?: boolean }>();
  const current = result?.request === request ? result : undefined;

  useEffect(() => {
    let cancelled = false;
    void AppData.loadServer(request.apiClient).then((response) => {
      serverAppURL(response.host, "signup/app", false);
      if (!cancelled) setResult({ request, host: response.host });
    }).catch((error: unknown) => {
      if (cancelled) return;
      logger.error(error);
      setResult({ request, failed: true });
    });
    return () => { cancelled = true; };
  }, [request]);

  const signup = current?.host ? serverAppURL(current.host, "signup/app", iOSApp) : undefined;
  return (
    <div className="LoginWelcomeView-signup" aria-busy={!current}>
      <LocalizedMessage
        message={(m) => iOSApp ? m.login.welcomeAppiPad : m.login.welcomeApp}
        html={true}
        links={{ "logbook:signup": signup }}
      />
      {current?.failed && (
        <>
          <div className="LoginView-error" role="alert">{t("signup_link_unavailable")}</div>
          <button type="button" className="button default" onClick={() => setAttempt((value) => value + 1)}>
            {t("signup_link_retry")}
          </button>
        </>
      )}
    </div>
  );
}

export function LoginWelcomeView({ message, invitationToken, invitationData }: LoginWelcomeViewProps) {
  const app = GetApp()!;
  const t = app.getT("LoginView");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete replacement-values type
  const invitationReplace = invitationData as any;

  return (
    <>
      <h2>{t("welcome")}</h2>

      {/* Welcome text on top of the boxes for login, signup */}
      {message == "signup_success" ? (
        <LocalizedMessage message={(m) => m.login.signupSuccess} html={true} />

      // opened by invitation
      ) : invitationToken && invitationData ? (
        <LocalizedMessage message={(m) => app.user ? m.login.invitationLoggedIn : m.login.invitation} html={true} replace={invitationReplace} />
      ) :

      // normal login/signup
          (app.cloudSession() ? (
            <LocalizedMessage message={(m) => m.login.welcomeCloud} html={true} />
          ) : (
            <NativeWelcomeMessage />
          )
          )}
    </>
  );
}
